import { render, staticRenderFns } from "./mudarpermissao.vue?vue&type=template&id=7df0f21e&scoped=true&"
import script from "./mudarpermissao.vue?vue&type=script&lang=js&"
export * from "./mudarpermissao.vue?vue&type=script&lang=js&"
import style0 from "./mudarpermissao.vue?vue&type=style&index=0&id=7df0f21e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df0f21e",
  null
  
)

export default component.exports